// extracted by mini-css-extract-plugin
module.exports = {"parameter":"CardParameterItem_parameter__wXasQ"};